module.exports = __webpack_public_path__ + "static/1-99082c34fd57470361419ce247428b84.jpg";